/* eslint-disable react/jsx-key */
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import Radio from "app/pages/.shared/form/Radio";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { insuranceShape } from "app/utils/propTypes";
import classNames from "classnames";
import AmountSign from "app/pages/.shared/AmountSign/AmountSign";
import InsuranceContent from "app/pages/Booking/Payment/Insurances/InsuranceContent";
import InsuranceMessagePlaceholder from "@brand/Payment/InsuranceMessagePlaceholder";

import "./insurances.scss";

const Insurances = ({ insurances, intro, logo, field, onChange, isSpecialOfferActive }) => {
	return (
		<div className="insurances">
			<div className="insurances__message-placeholder">
				<InsuranceMessagePlaceholder />
			</div>

			{/* covid banner */}
			{!isSpecialOfferActive && (
				<div className="insurances__item insurances__covid-banner">
					<p className="insurances__covid-banner__badge">
						<FormattedMessage id="payment.insurance.covid.badge.label" />
					</p>
					<p>
						<FormattedMessage id="payment.insurance.covid.badge.desc" />
					</p>
				</div>
			)}

			{(intro || isSpecialOfferActive) && (
				<div className="insurances__intro">
					<div>
						{isSpecialOfferActive ? "Compléter avec une option d'assurance" : intro}
					</div>
					<img className="insurances__logo" src={logo} />
				</div>
			)}

			{insurances.map((insurance, index) => {
				return (
					<div
						className={classNames("insurances__item", {
							"insurances__item--first": index === 0,
							"insurances__item--subsequent":
								index > 0 && index + 1 !== insurances.length,
							"insurances__item--last": index > 0 && index + 1 === insurances.length,
						})}
						key={insurance.code}
					>
						<Radio
							field={field}
							name={insurance.code}
							id={insurance.code}
							value={insurance.code}
							checked={field.value === insurance.code}
							showIcon={true}
							body={
								<InsuranceContent
									field={field}
									insurance={insurance}
									isFirstItem={index === 0}
								/>
							}
							toggle={() => {
								onChange(insurance);
							}}
							data-cy={`insurance-input-${insurance.code}`}
						>
							<div className="insurances__content">
								<div className="insurances__header">
									<div className="insurances__name">
										{insurance.title1 ? insurance.title1 : insurance.name}
									</div>
									{insurance.splittedPrice > 0 && (
										<div className="insurances__price">
											<AmountContainer
												amount={insurance.splittedPrice}
												prefix={<AmountSign sign="+" />}
											/>
											<div className="insurances__price__note">
												<FormattedMessage id="payment.insurance.price.per.day.per.person" />
											</div>
										</div>
									)}
								</div>
							</div>
						</Radio>
					</div>
				);
			})}
		</div>
	);
};

Insurances.defaultProps = {
	insurances: [],
	field: {},
};

Insurances.propTypes = {
	field: PropTypes.object,
	onChange: PropTypes.func,
	intro: PropTypes.string,
	logo: PropTypes.string,
	insurances: PropTypes.arrayOf(insuranceShape),
	isSpecialOfferActive: PropTypes.bool,
};

export default React.memo(Insurances);
